import React from 'react'
import { Box, Button, Paper, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'

Show.layout = (page) => <AppShell>{page}</AppShell>

export default function Show({ property, fiscal_year, accounts_count, sub_accounts_count }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  const handleProvisionSubAccounts = () => {
    router.patch(`${basePath}/fiscal_years/${fiscal_year.id}/provision_sub_accounts`)
  }

  const handleCloseYear = () => {
    router.patch(`${basePath}/fiscal_years/${fiscal_year.id}/close_year`)
  }

  return (
    <Box>
      <PageHeader
        title={`Geschäftsjahr ${fiscal_year.start_date} – ${fiscal_year.end_date}`}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Geschäftsjahre', href: `${basePath}/fiscal_years` },
          { label: `${fiscal_year.start_date} – ${fiscal_year.end_date}` },
        ]}
        actions={
          <Box sx={{ display: 'flex', gap: 1 }}>
            {fiscal_year.status === 'open' && (
              <>
                <Button variant="outlined" size="small" onClick={handleProvisionSubAccounts} data-testid="provision-btn">
                  Personenkonten anlegen
                </Button>
                <Button variant="outlined" size="small" color="warning" onClick={handleCloseYear} data-testid="close-year-btn">
                  Geschäftsjahr schließen
                </Button>
              </>
            )}
            <Button variant="outlined" size="small" startIcon={<EditIcon />}
              onClick={() => router.visit(`${basePath}/fiscal_years/${fiscal_year.id}/edit`)}
              data-testid="edit-fiscal-year-btn"
            >
              Bearbeiten
            </Button>
          </Box>
        }
      />

      <Paper elevation={0} sx={{ p: 3, border: '1px solid', borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', mb: 3 }}>
          <StatusBadge type="fiscal_year_status" value={fiscal_year.status} />
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">Zeitraum</Typography>
            <Typography variant="body2">{fiscal_year.start_date} – {fiscal_year.end_date}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Kontenplan</Typography>
            <Typography variant="body2">{fiscal_year.chart_of_accounts_name}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Template</Typography>
            <Typography variant="body2">{fiscal_year.chart_of_accounts_template?.toUpperCase()}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Konten / Personenkonten</Typography>
            <Typography variant="body2">{accounts_count} / {sub_accounts_count}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Buchungen</Typography>
            <Typography variant="body2">{fiscal_year.journal_entries_count}</Typography>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}
